import React from "react";
import AppShell from "../components/app/AppShell";
import PageHeader, { EmptyState } from "../components/app/PageHeader";
import { Copy, Folder, Settings as Cog, LifeBuoy } from "lucide-react";

export function Templates() {
  return (
    <AppShell>
      <PageHeader title="Templates" subtitle="Save reusable onboarding flows for your team." />
      <EmptyState icon={Copy} title="Template library coming soon" description="Use 'Create flow' on the Flows page to start from one of our pre-built templates (IFA, Mortgage, Documents)." />
    </AppShell>
  );
}

export function Documents() {
  return (
    <AppShell>
      <PageHeader title="Document library" subtitle="Shared documents used across your onboarding flows." />
      <EmptyState icon={Folder} title="Document library coming soon" description="Centralised document storage with AES-256 encryption launches in the next phase." />
    </AppShell>
  );
}

export function Settings() {
  return (
    <AppShell>
      <PageHeader title="Firm settings" subtitle="Manage your firm profile, branding, team, and billing." />
      <EmptyState icon={Cog} title="Settings UI coming soon" description="Profile + branding can be edited via the onboarding wizard. Full settings UI lands in Phase 3." />
    </AppShell>
  );
}

export function Help() {
  return (
    <AppShell>
      <PageHeader title="Help & support" subtitle="We're here to help." />
      <div className="card2 p-8 max-w-2xl">
        <p className="t-body mb-4">Need a hand? Email us at <a href="mailto:hello@compliche.com" className="text-indigo2 hover:underline">hello@compliche.com</a> and we'll respond within 4 hours on Professional plan.</p>
        <p className="t-body-sm text-slate2">For security disclosure, please use our PGP-encrypted channel (link coming in Phase 3).</p>
      </div>
    </AppShell>
  );
}
